import { useTranslation } from 'react-i18next'

import { getCopyrightText } from 'config'
import { EXTERNAL_PATH } from 'lib/paths'

import AppDownloadAds from 'components/AppDownloadAds'
import { ExternalLink } from 'components'

import './style.scss'

const Footer = () => {
  const { t } = useTranslation()

  return (
    <div className="Footer">
      <div className="Footer__section">
        <div className="container">
          <div className="Footer__section__wrapper">
            <AppDownloadAds />

            <div className="Footer__section__2">
              <h5>Yay!</h5>

              <ul className="Footer__nav">
                <li className="Footer__nav__list">
                  <ExternalLink href={EXTERNAL_PATH.POLICY()}>
                    {t('common.privacy_policy')}
                  </ExternalLink>
                </li>

                <li className="Footer__nav__list">
                  <ExternalLink href={EXTERNAL_PATH.TERM()}>
                    {t('common.term_of_use')}
                  </ExternalLink>
                </li>
              </ul>
            </div>

            <div className="Footer__section__3">
              <h5>{t('common.operating_company')}</h5>

              <ul className="Footer__nav">
                <li className="Footer__nav__list">
                  <ExternalLink href={EXTERNAL_PATH.NANAMEUE()}>
                    nanameue, Inc.
                  </ExternalLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="Footer__end">
        <div className="container">
          <div className="Footer__end__wrapper">{getCopyrightText()}</div>
        </div>
      </div>
    </div>
  )
}

export default Footer
